export const forwardingFormat = {
  jsonDefault: 'jsonDefault',
  jsonEnumAsInt: 'jsonEnumAsInt',
  jsonDefaultUtc: 'jsonDefaultUtc'
} as const;

export type ForwardingFormat =
  (typeof forwardingFormat)[keyof typeof forwardingFormat];
